import React from 'react';

// Types
import { ReviewFormTemplateType } from 'Shared/types/ReviewFormTemplate.type';

// Hooks
import { useReviewFormTemplate } from 'Shared/utils/hooks/use-review-form-template';

// Components
import { WpIcon } from 'Wpds/components/icon';
import { WpText } from 'Wpds/components/text';
import { WpBadge } from 'Wpds/components/badge';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';

// Styles
import './ReviewFormTemplateListItem.scss';

type Props = {
  reviewFormTemplate: ReviewFormTemplateType;
  setActiveSlide: Function;
};

const ReviewFormTemplateListItem = ({ reviewFormTemplate, setActiveSlide }: Props) => {
  const { title, description, questionCount, formErrors, questionErrors } = useReviewFormTemplate({
    reviewFormTemplate,
  });
  const isIncomplete = formErrors.length > 0 || questionErrors.length > 0;

  const handleClick = () => setActiveSlide(reviewFormTemplate.formType);

  const baseClassName = 'ReviewFormTemplateListItem';
  return (
    <WpContainer className={baseClassName} onClick={handleClick}>
      <WpContainerBody>
        <div className={`${baseClassName}__body`}>
          <div className={`${baseClassName}__body__name`}>
            <WpText tag="h5" variant="bodyLg" noMargin bold>
              {title}
              {isIncomplete && (
                <span className={`${baseClassName}__body__name__badge`}>
                  <WpBadge color="red">Incomplete</WpBadge>
                </span>
              )}
            </WpText>
            <WpText tag="span" color="gray-600">
              {description}
            </WpText>
          </div>
          <div className={`${baseClassName}__body__count`}>
            <WpText tag="span" bold color={questionCount === 0 ? 'red-600' : 'gray-900'}>
              {questionCount}
            </WpText>
            <WpText tag="span" color="gray-600">
              question{questionCount === 1 ? '' : 's'}
            </WpText>
          </div>
          <WpIcon name="chevron-right" />
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default ReviewFormTemplateListItem;
